import {
  IsArray,
  IsInt,
  IsNumber,
  IsOptional,
  IsString,
} from 'class-validator';

export class BoipaTokenizeResponseDto {
  @IsString()
  result: string;

  @IsNumber()
  @IsOptional()
  merchantId?: number;

  @IsString()
  @IsOptional()
  cardToken?: string;

  @IsString()
  @IsOptional()
  customerId?: string;

  @IsString()
  @IsOptional()
  cardType?: string;

  @IsString()
  @IsOptional()
  cardIssuer?: string;

  @IsString()
  @IsOptional()
  country?: string;

  @IsString()
  resultId: string;

  @IsInt()
  processingTime: number;

  @IsArray()
  @IsOptional()
  additionalDetails?: any[];

  @IsArray()
  @IsOptional()
  errors?: string[];
}
